import { TraceableProcess, TrackingEvent } from '../../../services/analytics/model';

export class UserContactInfoCompleted implements TrackingEvent {
  public readonly category = TraceableProcess.USER_PROFILE;
  public readonly action = 'User Contact Completed';
  public readonly label = 'Complete the information of contact from /ingreso';

  constructor(public readonly userId: number) {}
}
